import { Component, input, model, output } from '@angular/core';
import { KeyValueDescriptionType } from '@models/common/keyValueModel';

import { CipoControl, CipoFieldConfig, CipoFieldTypes } from '@shared/components/fields/common';
import { FroalaConfig } from '@shared/components/froala/common';
import { FroalaComponent } from '@shared/components/froala/froala.component';
import { CipoFieldsModule } from '@shared/modules';

@Component({
  selector: 'cipo-control',
  imports: [CipoFieldsModule, FroalaComponent],
  templateUrl: './cipo-control.component.html',
})
export class CipoControlComponent {
  control = input<CipoControl>();
  fieldData = model<CipoFieldConfig>();
  onblur = output<void>();
  FIELD_TYPES = CipoFieldTypes;
  FroalaConfig = FroalaConfig;
}
